<template>
  <main>
    <b-row>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/penjualan')" icon="ShoppingCartIcon" color="primary" :statistic="cardPenjualan" statistic-title="Total Penjualan" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/collection')" icon="CreditCardIcon" color="success" :statistic="cardCollection" statistic-title="Collection" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/barang')" icon="ArchiveIcon" color="warning" :statistic="cardBarang" statistic-title="Barang" />
      </b-col>
      <b-col lg="3" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/kendaraan-barang')" icon="BoxIcon" color="danger" :statistic="cardStokBarang" statistic-title="Stok Barang (Mobil)" />
      </b-col>
      <b-col lg="4" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/kendaraan')" icon="TruckIcon" color="primary" :statistic="cardKendaraan" statistic-title="Total Kendaraan" />
      </b-col>
      <b-col lg="4" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/karyawan')" icon="UsersIcon" color="success" :statistic="cardKaryawan" statistic-title="Total Karyawan" />
      </b-col>
      <b-col lg="4" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/rank-sales')" icon="BarChart2Icon" color="warning" :statistic="cardSales" statistic-title="Rank Sales" />
      </b-col>
      <b-col cols="12"> <sales-graphic /> </b-col>
      <br />
      <br />
      <b-col cols="12">
        <profit-and-loss-graphic />
      </b-col>
      <br />
      <br />
    </b-row>
  </main>
</template>
<script>
import { BAlert } from "bootstrap-vue";
import { BTabs, BTab, BRow, BCol, BCard } from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import AppEchartBar from "@core/components/charts/echart/AppEchartBar.vue";
import SalesGraphic from './_penjualan.vue'
import ProfitAndLossGraphic from './_profit_and_loss.vue'
export default {
  data() {
    return {
      dataPenjualan: {},
      card: {},
      dataLabaRugi: {},
      dataChartBar2: {
        xAxis: {
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            type: "bar",
            data: [],
          },
        ],
      },
      dataChartLine: {
        xAxisData: ["Satu", "Dua", "Tiga", "Empat", "Lima", "Enam"],
        series: [23000, 40000, 30000, 60000, 10000, 40000],
      },
    };
  },
  components: {
    SalesGraphic,
    StatisticCardHorizontal,
    ProfitAndLossGraphic,
    BAlert,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    AppEchartBar
  },
  computed: {
    myName() {
      if (this.user) {
        return this.user.karyawan ? this.user.karyawan.nama_lengkap : this.user.email;
      }

      return null;
    },
    cardPenjualan() {
      return "Rp " + this.formatRupiah(this.card.penjualan);
    },
    cardStokBarang() {
      return "Rp " + this.formatRupiah(this.card.barangMobilNilai);
    },
    cardSales() {
      return this.card.sales + " Orang";
    },
    cardCollection() {
      return "Rp " + this.formatRupiah(this.card.collection);
    },
    cardKendaraan() {
      return this.card.kendaraan ? this.card.kendaraan + " Unit" : "0 Unit";
    },
    cardBarang() {
      return this.card.kendaraan ? this.card.barangTotal + " Item" : "0 Item";
    },
    cardKaryawan() {
      return this.card.karyawan + " Orang";
    },
  },
  methods: {
    postCardInfo() {
      let payload = {
        show: {
          penjualan: true,
          sales: true,
          karyawan: true,
          collection: true,
          barangTotal: true,
          kendaraan: true,
          assetTotal: true,
          assetNilai: true,
          barangMobilNilai: true,
          keuntungan: false,
        },
      };
      this.$store
        .dispatch("dashboard/cardInfo", payload)
        .then((res) => {
          this.card = res;
        })
        .catch((e) => console.error(e));
    },
  },

  mounted() {
    this.postCardInfo();
  },
};
</script>
